import React from 'react';
import { ButtonPillView } from '../Buttons/ButtonPillView';
import { THandleButtonClick } from './utils/types';
import styles from './Calculator.module.css';

type TCalculatorButtonProps = {
    isEnabled: boolean;
    label: string;
    handleClick: THandleButtonClick;
};
const CalculatorButton = React.memo(({ isEnabled, label, handleClick }: TCalculatorButtonProps) => {
    return (
        <div className={styles.calculatorButtonStyled}>
            <ButtonPillView
                hierarchy="primary"
                position="floating"
                size={'large'}
                label={label ?? ''}
                onClick={handleClick}
                isDisabled={!isEnabled}
                maxWidth="100%"
            />
        </div>
    );
});
export { CalculatorButton };
